import React, { Fragment } from 'react';
import { Button } from 'ra-ui-materialui';
import { Send as SendIcon } from '@material-ui/icons';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import '../../styles.css';

class ShowActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
      dialogBody: null,
    };
  }

  handleClick = async (overrideStatus = false) => {
    const {
      dataProvider,
      resource,
      data,
      setSubmitting,
    } = this.props;

    if (!overrideStatus && data.status === 'inactive') {
      this.setState({
        isDialogOpen: true,
        dialogBody: (
          <span>
            This user has been placed under lock by an admin.
            If you choose to proceed with this action, the user will in turn be unlocked.
            Do you wish to continue with sending the password reset email?
            <br />
          </span>),
      });
      return;
    }
    if (!overrideStatus && data.status === 'review') {
      this.setState({
        isDialogOpen: true,
        dialogBody: (
          <span>
            This user has has tried to log in more times than allowed, and as a consequence he is under review.
            <br />
            If you choose to proceed with this action, you will override their under review status.
            <br />
            Do you wish to continue with sending the password reset email?
          </span>
        ),
      });
      return;
    }
    this.setState({ isDialogOpen: false, dialogBody: null });
    setSubmitting(true);
    dataProvider('RESET_PASSWORD', resource, { id: data.id, email: data.email, isAdmin: true }, {
      onSuccess: {
        notification: { body: 'Email Sent Successfully!', level: 'info' },
        callback: () => {
          setSubmitting(false);
        },
        refresh: true,
      },
      onError: {
        notification: { body: 'Email count not be sent!', level: 'warning' },
        callback: () => {
          setSubmitting(false);
        },
      },
    });
  };

  render() {
    const {
      isDialogOpen,
      dialogBody,
    } = this.state;
    return (
      <Fragment>
        <Button
          variant="contained"
          label="Send Password Reset Email"
          style={{ width: '100%', marginTop: 4 }}
          className="successButton userActionButton"
          onClick={() => this.handleClick()}
        >
          <SendIcon />
        </Button>
        <Dialog
          open={isDialogOpen}
          onClose={this.onDialogClose}
        >
          <DialogTitle id="alert-dialog-title">
              Proceed with sending email for password reset?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogBody}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="default"
              onClick={() => this.handleClick(true)}
              label="Yes"
              style={{ paddingRight: 15 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.setState({ isDialogOpen: false, dialogBody: null })}
              label="No"
              style={{ paddingRight: 15 }}
            />
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default(ShowActions);



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/SendResetPasswordEmailButton.jsx